import { IClassname } from '@/lib/shared/model/classname';

export const BathroomSVG = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23 14C23 14.2652 22.8946 14.5196 22.7071 14.7071C22.5196 14.8946 22.2652 15 22 15C21.7348 15 21.4804 14.8946 21.2929 14.7071C21.1054 14.5196 21 14.2652 21 14C21.2174 13.2814 21.5556 12.6051 22 12C22.4444 12.6051 22.7826 13.2814 23 14Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 21V19.6667C19 18.9594 19.1686 18.2811 19.4686 17.781C19.7687 17.281 20.1757 17 20.6 17H23"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 21V19.6667C13 18.9594 12.8314 18.2811 12.5314 17.781C12.2313 17.281 11.8243 17 11.4 17H9"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.39114 21C6.32233 21.0001 6.25477 21.0146 6.19525 21.0422C6.13573 21.0698 6.08634 21.1093 6.05207 21.157C6.01779 21.2046 5.99984 21.2586 6 21.3135C6.00017 21.3685 6.01845 21.4224 6.05301 21.4699C7.07528 22.8443 8.52602 23.9839 10.2639 24.7778C12.0018 25.5717 13.9676 25.9927 15.9699 25.9999C17.9722 26.0071 19.9427 25.6002 21.6894 24.8188C23.4362 24.0375 24.8997 22.9083 25.9375 21.5413C25.9777 21.4871 25.9993 21.4253 26 21.3623C26.0007 21.2993 25.9805 21.2373 25.9414 21.1825C25.9023 21.1277 25.8458 21.0822 25.7775 21.0505C25.7093 21.0188 25.6318 21.0022 25.5528 21.0021L6.39114 21Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 21V9.51562C16 8.58322 16.3161 7.68901 16.8787 7.0297C17.4413 6.3704 18.2044 6 19 6C19.7956 6 20.5587 6.3704 21.1213 7.0297C21.6839 7.68901 22 8.58322 22 9.51562V10.2187"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
